var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-panel-padding full-width-image-panel"},[(_vm.data.image)?_c('PositionedResponsiveImage',{attrs:{"image":_vm.data.image}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }